import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, ErrorMessage } from 'formik';
import {
  Box,
  Flex,
  Button,
  Heading,
  Text,
  Textarea,
  VStack,
  IconButton,
  Collapse,
  ListItem,
  UnorderedList,
  FormControl,
  FormErrorMessage,
  useDisclosure,
} from '@chakra-ui/react';
import { TbChevronsDown, TbChevronsUp } from 'react-icons/tb';
import { AnswerBox } from '../style/WritingPracticePage.styles';

function Outline({ idx, outline, isSubmitting, updateOutline, assistantChat }) {
  const { isOpen, onToggle } = useDisclosure();

  let { task, tips, mandatory, status, answer } = outline;

  return (
    <Box p={3} borderWidth="1px" borderRadius="lg" boxShadow="md" mb={4}>
      <Flex>
        <Heading size="sm">{task}</Heading>
        <IconButton
          size="sm"
          onClick={onToggle}
          ml="1rem"
          icon={isOpen ? <TbChevronsUp /> : <TbChevronsDown />}
        />
      </Flex>
      <Collapse in={isOpen} unmountOnExit>
        <UnorderedList mt="8px" color="gray">
          {tips?.map((tip, i) => (
            <ListItem key={i} size="sm">
              {tip}
            </ListItem>
          ))}
        </UnorderedList>
      </Collapse>
      {status === 'Done' || status === 'Skipped' ? (
        status === 'Done' ? (
          <AnswerBox bg="#F0FFF4">
            <Text>{answer}</Text>
          </AnswerBox>
        ) : (
          <AnswerBox bg="#FFF5F5">
            <Text>Skipped</Text>
          </AnswerBox>
        )
      ) : (
        <Formik
          initialValues={{ answer: answer }}
          enableReinitialize
          // onSubmit={(values) => {
          //   console.log('Form submitted:', values);
          // }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            // isSubmitting,
          }) => (
            <Form id={`outline_${idx}`}>
              <VStack spacing={4} mt={4} align="stretch">
                <FormControl isInvalid={errors.answer && touched.answer}>
                  {/* Textarea Field */}
                  <Textarea
                    name="answer"
                    placeholder="Write your outlines here ..."
                    size="lg"
                    // resize="none"
                    rows={6} // Default 10 lines
                    minHeight="6em" // Ensure at least 10 lines of height
                    value={values.answer}
                    onChange={(e) => {
                      handleChange(e);
                      // setCurrIdeas(e.target.value);
                    }}
                    onBlur={handleBlur} // Marks the field as touched
                  />

                  <FormErrorMessage>
                    <ErrorMessage name="answer" />
                  </FormErrorMessage>
                </FormControl>

                <Flex>
                  {mandatory ? null : (
                    <Button
                      size="sm"
                      // mb="1rem"
                      mr="1rem"
                      onClick={() => updateOutline(values?.answer, idx, 3)}
                    >
                      Skip
                    </Button>
                  )}
                  <Button
                    size="sm"
                    // mb="1rem"
                    mr="1rem"
                    isLoading={isSubmitting}
                    onClick={() => assistantChat(values?.answer, idx, 2)}
                  >
                    I&apos;m stuck
                  </Button>
                  <Button
                    size="sm"
                    // mb="1rem"
                    mr="1rem"
                    isLoading={isSubmitting}
                    onClick={() => assistantChat(values?.answer, idx, 3)}
                  >
                    Evaluate
                  </Button>
                  <Button
                    form={`outline_${idx}`}
                    size="sm"
                    // mb="1rem"
                    mr="1rem"
                    isLoading={isSubmitting}
                    onClick={() => updateOutline(values?.answer, idx, 1)}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    // mb="1rem"
                    mr="1rem"
                    isLoading={isSubmitting}
                    onClick={() => updateOutline(values?.answer, idx, 2)}
                  >
                    Submit
                  </Button>
                </Flex>
              </VStack>
            </Form>
          )}
        </Formik>
      )}
    </Box>
  );
}

Outline.propTypes = {
  idx: PropTypes.number.isRequired,
  outline: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.string,
  isSubmitting: PropTypes.bool,
  updateOutline: PropTypes.func,
  assistantChat: PropTypes.func,
};

export default Outline;
